import React from 'react';
interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'premium';
}
export function Badge({
  variant = 'default',
  className = '',
  children,
  ...props
}: BadgeProps) {
  const variants = {
    default: 'bg-primary-100 text-primary-700 border-primary-200/50',
    secondary: 'bg-slate-100 text-slate-700 border-slate-200/50',
    success: 'bg-green-100 text-green-700 border-green-200/50',
    warning: 'bg-amber-100 text-amber-700 border-amber-200/50',
    destructive: 'bg-red-100 text-red-700 border-red-200/50',
    premium: 'badge-premium'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${variants[variant]} ${className}`} {...props} data-id="element-353">
      {children}
    </span>;
}